// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"25":"0f207f1b","344":"1f49ef11","581":"27f1aeec"}[chunkId] + ".css";
};